import { useLocation, useParams } from "react-router-dom";
// import Scanner from "../Components/Scanner";
import { useEffect, useState } from "react";
import axios from "axios";
import WineProduct from "./WineProduct";
import Banner from "../Components/Banner";

const WinePage = () => {

  const { wine_name } = useParams();
  const [restData, setRestData] = useState();
  // console.log("🚀 ~ WinePage ~ restData:", restData)
  const [winesData, setWinesData] = useState([]);
  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;
  const logo = restData?.wineList?.restaurant?.logo ? `${logoUrl}/${restData?.wineList?.restaurant.logo}` : null;
  const [priceFilter, setPriceFilter] = useState("asc");
  const [priceType, setPriceType] = useState("bottle_price");
  const [description, setDescription] = useState("");
  const [showModalReg, setShowModalReg] = useState(false);
  const location = useLocation();

  // State Management: Filters
  const [filteredNation, setFilteredNation] = useState("");
  const [filteredRegion, setFilteredRegion] = useState("");
  const [filteredWine, setFilteredWine] = useState("");
  const [filteredProductType, setFilteredProductType] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const urlPriceType = params.get("priceType");
    const urlPriceFilter = params.get("priceFilter");

    // update only if value exists
    if (urlPriceType !== null && urlPriceType !== "") {
      setPriceType(urlPriceType);
    }

    if (urlPriceFilter !== null && urlPriceFilter !== "") {
      setPriceFilter(urlPriceFilter);
    }

  }, [location.search]);

  // Price range filters
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  // QR Code Scanned URL state
  // const [scannedUrl, setScannedUrl] = useState("");

  useEffect(() => {
    setIsLoading(true);
    const params = {
      sort_by: priceType,
      sort_type: priceFilter,
    };
    if (filteredNation.length > 0) {
      params.nation = filteredNation.join(",");
    }
    if (filteredRegion.length > 0) {
      params.region = filteredRegion.join(",");
    }
    if (filteredWine.length > 0) {
      params.wine = filteredWine.join(",");
    }
    if (filteredProductType.length > 0) {
      params.product_type = filteredProductType.join(",");
    }
    if (minPrice) {
      params.sort_bottle_price_min = minPrice;
    }
    if (maxPrice) {
      params.sort_bottle_price_max = maxPrice;
    }
    axios
      .get(`${apiUrl}/api/v1/wine-list/${wine_name}`, {
        params,
      })
      .then((res) => {
        if (res.status === 200) {
          setRestData(res.data);
          setWinesData(res?.data?.wines || []);
          setDescription(res?.data?.wineList?.description);
        } else {
          setRestData();
          setWinesData([]);
        }
      })
      .catch((error) => {
        // setRestData();
        setWinesData(error?.response?.data?.wines || []);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [
    filteredNation,
    filteredProductType,
    filteredRegion,
    filteredWine,
    priceFilter,
    wine_name,
    priceType,
    minPrice,
    maxPrice,
    apiUrl,
  ]);

  // const handleQRCodeScan = (url) => {
  //   setScannedUrl(url);
  // };

  return (
    <div className="loader-section flex flex-col w-full h-[100vh] overflow-y-scroll">
      <Banner
        desc={description}
        restaurantId={restData?.wineList?.restaurant?.id}
        logo={logo}
        showModalReg={showModalReg}
        setShowModalReg={setShowModalReg}
        restaurantName={restData?.wineList?.restaurant?.restaurant_name || ""}
        showSentence={restData?.wineList?.is_show_sentence}
      />
      {!showModalReg &&
        <WineProduct
          isLoading={isLoading}
          priceType={priceType}
          setPriceType={setPriceType}
          filteredNation={filteredNation}
          setFilteredNation={setFilteredNation}
          filteredRegion={filteredRegion}
          setFilteredRegion={setFilteredRegion}
          filteredWine={filteredWine}
          setFilteredWine={setFilteredWine}
          filteredProductType={filteredProductType}
          setFilteredProductType={setFilteredProductType}
          priceFilter={priceFilter}
          setPriceFilter={setPriceFilter}
          minPrice={minPrice}
          setMinPrice={setMinPrice}
          maxPrice={maxPrice}
          setMaxPrice={setMaxPrice}
          wineData={restData ? restData : []}
          winesData={winesData}
        />
      }
      {/* <Scanner
        wineData={restData?.wineList ? restData?.wineList : []}
        onScan={(url) => handleQRCodeScan(url)}
      /> */}
    </div>
  );
};

export default WinePage;
